import { useEffect } from "react";

function Court() {
  useEffect(() => {
    document.title = "Court";
  });
  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Court</h1>
          </div>
          <div class="flex-vert" style={{ marginTop: "-10px" }}>
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Wiess Court is an elected student body responsible for
              communicating and upholding the college’s expectations for
              appropriate student behavior. Wiess Court is not a punitive force,
              but instead acts to promote an environment of mutual respect.
            </p>
          </div>
          {/* <div style={{ marginTop: "10px" }}>
            <a
              href="https://forms.gle/1mrj3tJqjgngcxDZ9"
              class="popup-button blm-button"
            >
              Report a College Infraction
            </a>
          </div> */}
        </div>
        <div class="people-section">
          <div id="courtnav" class="from-navbar-ref"></div>
          <div id="court" class="page-nav-ref"></div>
          <div class="court-grid">
            <div id="court-CJ-card-holder">
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/cab-faces/virginia-minard.jpg"
                    height="200"
                    alt="Virginia Minard"
                  />
                </div>
                <div>
                  <p class="position">Chief Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Virginia Minard</h4>
                </div>
                <div>
                  <a class="position" href="mailto: wiesscourt@gmail.com">
                    <u>wiesscourt@gmail.com</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2025-26/court-faces/COURT_AJ_SaraKalra.jpg"
                    height="200"
                    alt="Sara Kalra"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Sara Kalra</h4>
                  <a class="position" href="mailto: srk15@rice.edu">
                    <u>srk15@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/court-faces/Austen Kuhn.JPG"
                    height="200"
                    alt="Austen Kuhn"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Austen Kuhn</h4>
                  <a class="position" href="mailto: ak231@rice.edu">
                    <u>ak231@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/court-faces/Sergio Karam.jpg"
                    height="200"
                    alt="Sergio Karam"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Sergio Karam</h4>
                  <a class="position" href="mailto: sbk8@rice.edu">
                    <u>sbk8@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/court-faces/Katherine Kyles.jpeg"
                    height="200"
                    alt="Katherine Kyles"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Katherine Kyles</h4>
                  <a class="position" href="mailto: kk150@rice.edu">
                    <u>kk150@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/court-faces/Aaryan Vira.jpg"
                    height="200"
                    alt="Savan Patel"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Aaryan Vira</h4>
                  <a class="position" href="mailto: av123@rice.edu">
                    <u>av123@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                  src="/images2026-27/court-faces/David Uchime.jpeg"
                    height="200"
                    alt="Wiess Crest"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">David Uchime</h4>
                  <a class="position" href="mailto: du6@rice.edu">
                    <u>du6@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/court-faces/Jennifer Han.png"
                    height="200"
                    alt="Jennifer Han"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Jennifer Han</h4>
                  <a class="position" href="mailto: jh336@rice.edu">
                    <u>jh336@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div class="person-card">
                <div class="prof-pic">
                  <img
                    src="/images2026-27/court-faces/Amanda Yee.jpeg"
                    height="200"
                    alt="Amanda Yee"
                  />
                </div>
                <div>
                  <p class="position">Associate Justice</p>
                </div>
                <div class="name">
                  <h4 class="h4">Amanda Yee</h4>
                  <a class="position" href="mailto: ay57@rice.edu">
                    <u>ay57@rice.edu</u>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Court;
